import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { SingleLineEllipsis } from 'components/styles';

const IconWrapper = styled.span``;
const NameWrapper = styled.span`
  ${SingleLineEllipsis};
`;

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;

  ${IconWrapper} {
    display: inline-flex;
    flex-shrink: 0;
  }
  ${NameWrapper} {
    flex: 1;
    max-width: 100%;
  }
`;

interface Props {
  name: string;
  deleted?: boolean;
  trashIcon?: ReactNode;
  className?: string;
}

export const CategoryName: FC<Props> = ({
  name,
  deleted = false,
  trashIcon = <TrashCan16 />,
  className,
}) => (
  <Wrapper className={className}>
    {deleted ? <IconWrapper>{trashIcon}</IconWrapper> : null}
    <NameWrapper title={name}>{name}</NameWrapper>
  </Wrapper>
);
